import { createSelector } from 'reselect';

const getState = state => state.statusSummary;

const getSummaries = createSelector([getState], state => state.get('data'));

export default {
  getSummaries,
};
